import { Group } from '@/core/api/entities/group'
import { useTranslation } from '@/core/i18n/useTranslation'
import { Checkbox } from '@/shared/components/atoms/Checkbox'
import { cn } from '@/shared/utils/helpers'

interface GroupRowProps {
	group: Group
	isSelected: boolean
	onSelectionChange: (checked: boolean) => void
	className?: string
}

export function GroupRow({
	group,
	isSelected,
	onSelectionChange,
	className,
}: GroupRowProps) {
	const { t } = useTranslation('common')

	const handleRowClick = () => {
		onSelectionChange(!isSelected)
	}

	const analytics = group.analytics
	const playlistsCount = group.directPlaylists ?? 0

	const analyticsText = [
		analytics.players > 0 &&
			`${analytics.players} ${analytics.players !== 1 ? t('entities.group.analytics.zones') : t('entities.group.analytics.zone')}`,
		analytics.schedules > 0 &&
			`${analytics.schedules} ${analytics.schedules !== 1 ? t('entities.group.analytics.schedules') : t('entities.group.analytics.schedule')}`,
		playlistsCount > 0 &&
			`${playlistsCount} ${playlistsCount !== 1 ? t('entities.group.analytics.playlists') : t('entities.group.analytics.playlist')}`,
	]
		.filter(Boolean)
		.join(', ')

	return (
		<div
			className={cn(
				'flex items-center justify-between px-4 py-4 hover:bg-accent/50 cursor-pointer',
				className
			)}
			onClick={handleRowClick}
		>
			<div className="flex-1 pr-4 flex flex-col justify-center">
				<p className={`text-sm font-medium ${analyticsText ? 'mb-1' : ''}`}>
					{group.name}
				</p>
				{analyticsText && (
					<p className="text-xs text-muted-foreground">{analyticsText}</p>
				)}
			</div>
			<Checkbox
				checked={isSelected}
				onCheckedChange={(checked) => onSelectionChange(checked === true)}
				onClick={(e) => e.stopPropagation()}
			/>
		</div>
	)
}
